<wr-base-dialog status="info" header="Kontaktperson auswählen oder eingeben" [submitResponse]="submit.bind(this)" [cancelResponse]="close.bind(this)">
  @if (form; as form) {
    <div>
      <nb-radio-group [(ngModel)]="selectedOption">
        <nb-radio value="user">Benutzer suchen</nb-radio>
        <nb-radio value="manual">Manuelle Eingabe</nb-radio>
      </nb-radio-group>

      @if (selectedOption === 'user') {
        <div>
          <wr-user-select id="userId" [formControl]="$any(form).get('user')" [tenantIds$]="tenantIds$"></wr-user-select>
        </div>
      }

      @if (selectedOption === 'manual') {
        <div>
          <form [formGroup]="form" class="grid">
            <label class="label" for="firstName">Vorname</label>
            <input id="firstName" nbInput fullWidth formControlName="firstName">

            <label class="label" for="lastName">Nachname</label>
            <input id="lastName" nbInput fullWidth formControlName="lastName">

            <label class="label" for="email">Email</label>
            <input id="email" nbInput fullWidth formControlName="email">

            <label class="label" for="phone">Telefonnummer</label>
            <input id="phone" nbInput fullWidth formControlName="phone">
          </form>
        </div>
      }
    </div>
  }
</wr-base-dialog>
